import { ManufacturerContentModel } from './manufacturerContentModel';

export class ManufacturerAdminModel {
  public manufacturerId: number;
  public name: string;
  public address: string;
  public city: string;
  public country: string;
  public phone: string;
  public manufacturerContent: Array<ManufacturerContentModel>;
  //public List<MedicineDTO> Medicines { get; set; }
  //public int? ManufacturerTypeId { get; set; } //DTO or enum
  //public int? ManufacturerStatusId { get; set; } //DTO or enum
}